import { emailAuth } from "@utils/emailAuthUtils.ts";
import { Link as RouterLink } from "react-router-dom";
import { Link, Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export default function RequireEmailToken({
  children,
}: {
  children: React.ReactNode;
}) {
  const { t } = useTranslation();

  const [isTokenExpired, setIsTokenExpired] = useState(
    emailAuth.isTokenExpired(),
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setIsTokenExpired(emailAuth.isTokenExpired());
    }, 30000); // check every 30 seconds

    return () => {
      clearInterval(interval);
    };
  }, []);

  if (isTokenExpired) {
    return (
      <Stack spacing={3} padding={2}>
        <Typography variant="h4">{t("expiredEmailToken.header")}</Typography>
        <Stack spacing={2}>
          <Typography variant="subtitle1">
            <Trans i18nKey="expiredEmailToken.text" t={t}>
              <Link component={RouterLink} to="/invitation/login">
                täältä
              </Link>
            </Trans>
          </Typography>
        </Stack>
      </Stack>
    );
  }

  return children;
}
